import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

import TrainingCourseSuggestion from "./TrainingCourseSuggestion";

const slideAnimation = {
  initial: { opacity: 0, y: -12 },
  animate: { opacity: 1, y:   0 },
  exit:    { opacity: 0, y:  12 }
};

const TrainingCourseSuggestionList = ({ items, loading, onItemSelected }) => {

  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleItemSelected = (item, index) => {
    setSelectedIndex(index);
    onItemSelected && onItemSelected(item);
  }

  return (
    <div className="suggestions">
      <AnimatePresence exitBeforeEnter>
        {items.map(({ title, description }, index) => (
          <motion.div
            key={title}
            variants={slideAnimation}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3, delay: index * 0.1 }}
          >
            <TrainingCourseSuggestion
              title={title}
              description={description}
              selected={index == selectedIndex}
              disabled={loading}
              onClick={item => handleItemSelected(item, index)}
            />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}

export default TrainingCourseSuggestionList;
